/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filecategorycontract2Inputs */

const en_filecategorycontract2 = /** @type {(inputs: Filecategorycontract2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contract / quote`)
};

const pt_filecategorycontract2 = /** @type {(inputs: Filecategorycontract2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contrato / orçamento`)
};

/**
* | output |
* | --- |
* | "Contract / quote" |
*
* @param {Filecategorycontract2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const filecategorycontract2 = /** @type {((inputs?: Filecategorycontract2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filecategorycontract2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filecategorycontract2(inputs)
	return pt_filecategorycontract2(inputs)
});
export { filecategorycontract2 as "fileCategoryContract" }